import { Franchise } from '@/types';
import { Typography } from 'antd';

interface Props {
  franchisor: Partial<Franchise>;
}

export default function FranchiseDetailsAdminSection({ franchisor }: Props) {
  return (
    <div className={'details-section-column'}>
      <div className={'details-section-line'}>
        <Typography.Text className={'general-info-text'}>
          Brand Name
        </Typography.Text>
        <Typography.Text className={'general-info-value'}>
          {franchisor?.company ? franchisor.company : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className={'general-info-text'}>Logo</Typography.Text>
        <img
          src={franchisor?.logo}
          alt={'Logo'}
          width={24}
          height={24}
          style={{ borderRadius: 4, objectFit: 'contain', background: '#fff' }}
        />
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className={'general-info-text'}>
          Country
        </Typography.Text>
        <Typography.Text className={'general-info-value'}>
          {franchisor?.country ? franchisor.country : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className={'general-info-text'}>
          Established
        </Typography.Text>
        <Typography.Text className={'general-info-value'}>
          {franchisor?.established && typeof franchisor.established === 'string'
            ? new Date(franchisor.established).getFullYear()
            : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className={'general-info-text'}>
          Franchised Units
        </Typography.Text>
        <Typography.Text className={'general-info-value'}>
          {franchisor?.franchisedUnits != null ? franchisor.franchisedUnits : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className={'general-info-text'}>
          Franchises In Canada{' '}
        </Typography.Text>
        <Typography.Text className={'general-info-value'}>
          {franchisor?.franchisesInCanada !== undefined
            ? franchisor.franchisesInCanada
              ? 'Yes'
              : 'No'
            : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className={'general-info-text'}>
          Started Franchising{' '}
        </Typography.Text>
        <Typography.Text className={'general-info-value'}>
          {franchisor?.startedFranchising &&
          typeof franchisor.startedFranchising === 'string'
            ? new Date(franchisor.startedFranchising).getFullYear()
            : '-'}
        </Typography.Text>
      </div>

      <div className={'details-section-line'}>
        <Typography.Text className={'general-info-text'}>
          Corporate Units{' '}
        </Typography.Text>
        <Typography.Text className={'general-info-value'}>
          {franchisor?.corporateUnits ? franchisor.corporateUnits : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className={'general-info-text'}>
          International Franchises
        </Typography.Text>
        <Typography.Text className={'general-info-value'}>
          {franchisor?.otherInternationalFranchises !== undefined
            ? franchisor.otherInternationalFranchises
              ? 'Yes'
              : 'No'
            : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-column'}>
        <Typography.Text className={'general-info-text'}>
          Overview
        </Typography.Text>
        <Typography.Text className={'general-info-value'}>
          {franchisor?.otherInternationalFranchises !== undefined
            ? franchisor.otherInternationalFranchises
              ? 'Yes'
              : 'No'
            : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-column'}>
        <Typography.Text className={'general-info-text'}>
          Categories
        </Typography.Text>
        <Typography.Text className={'general-info-value'}>
          {franchisor?.groups?.length ? franchisor.groups.join(', ') : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-column'}>
        <Typography.Text className={'general-info-text'}>
          States Registered In
        </Typography.Text>
        <Typography.Text className={'general-info-value'}>
          {franchisor?.statesRegisteredIn?.length
            ? franchisor.statesRegisteredIn.join(', ')
            : '-'}
        </Typography.Text>
      </div>
    </div>
  );
}
